// extracted by mini-css-extract-plugin
module.exports = {"container":"style-module_container__23BWjJvt9kWJbK0rz-M4ro"};